import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Divider,
  TextField,
  Chip
} from '@mui/material';
import DetailItem from './DetailItem';
import DisponibilitePicker from './DisponibilitePicker';
import { disponibiliteOptions } from './constants/options';
import { useNavigate } from 'react-router-dom';
import './InfoCard.css';

const filteredOptions = disponibiliteOptions.filter(opt => opt.value !== 'immédiat');

const InfoCard = ({
  mission,
  editable,
  onChange,
  showActionButton = false,
  onActionClick,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onActionClick) {
      onActionClick();
    } else {
      navigate(`/recruteur/travailler-mission/${mission._id}`);
    }
  };

  return (
    <Card className="info-card-modern">
      <CardContent>
        <div className="info-header-modern">
          <Chip
            label={mission.status?.toUpperCase()}
            className={`status-chip ${mission.status === 'active' ? 'green' : 'red'}`}
          />
        </div>

        <Divider className="info-divider-modern" />

        {editable ? (
          <>
            <TextField
              label="Prime"
              type="number"
              fullWidth
              margin="normal"
              value={mission.remuneration || ''}
              onChange={(e) => onChange('remuneration', e.target.value)}
            />

            <TextField
              label="Devise"
              fullWidth
              margin="normal"
              value={mission.devise || ''}
              onChange={(e) => onChange('devise', e.target.value)}
            />

            <DisponibilitePicker
              label="Date limite"
              options={filteredOptions}
              value={mission.dateLimite}
              onChange={(val) => onChange('dateLimite', val)}
            />
          </>
        ) : (
          <>
            <div className="prime-block">
              <Typography variant="body2" className="prime-label">Prime Consultant</Typography>
              <Typography variant="h5" className="prime-value">
                {mission.remuneration ? `${mission.remuneration} ${mission.devise || '€'}` : 'N/A'}
              </Typography>
            </div>

            <DetailItem
              label="Date limite"
              value={
                mission.dateLimite
                  ? new Date(mission.dateLimite).toLocaleDateString('fr-FR', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                    })
                  : 'Non spécifiée'
              }
            />
          {mission.urgenceMission && (
            <Chip
              label={mission.urgenceMission.toUpperCase()}
              className={`status-chip ${mission.urgenceMission === 'Urgente' ? 'red' : 'green'}`}
            />
          )}
          </>
        )}

        {showActionButton && mission.status === 'active' && (
          <div className="info-button-modern">
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleClick}
              size="medium"
            >
              Proposer un talent
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default InfoCard;
